import { EnumNoPermissionErrorSource } from '@/common/models/enum'
import {SsoRedirect} from '@/router/models'

export default {
  state: {
    urlTo: {} as any,
    showNoPermissionErrorFlag: false as boolean,
    errorSource: EnumNoPermissionErrorSource.FromButton as EnumNoPermissionErrorSource,
    errorPageName: '' as string,
    ssoRedirectTo: {} as SsoRedirect,
    hasUpgrade: false,
  },
  getters: {
    urlTo: (state: any) => state.urlTo,
    showNoPermissionErrorFlag: (state: any) => state.showNoPermissionErrorFlag,
    errorSource: (state: any) => state.errorSource,
    errorPageName: (state: any) => state.errorPageName,
    ssoRedirectTo: (state: any) => state.ssoRedirectTo,
    hasUpgrade: (state: any) => state.hasUpgrade,
  },
  mutations: {
    setUrlTo(state: any, urlTo: any) {
      state.urlTo = urlTo
    },
    setShowNoPermissionErrorFlag(state: any, flag: boolean) {
      state.showNoPermissionErrorFlag = flag
    },
    setErrorSource(state: any, errorSource: EnumNoPermissionErrorSource) {
      state.errorSource = errorSource
    },
    setErrorPageName(state: any, msg: string) {
      state.errorPageName = msg
    },
    setSsoRedirectTo(state: any, to: SsoRedirect) {
      state.ssoRedirectTo = to
    },
    resetSsoRedirect(state: any) {
      state.ssoRedirectTo = {}
    },
    clean(state: any) {
      state.urlTo = {}
      state.showNoPermissionErrorFlag = false
      state.errorSource = EnumNoPermissionErrorSource.FromButton
      state.errorPageName = ''
    },
    setHasUpgrade(state: any, flag: boolean) {
      state.hasUpgrade = flag
    },
  },
  actions: {},
  namespaced: true,
}
